<ion-header mode="ios">
  <div class="top-nav-container" (click)="onContainerClick($event)">
    <div class="top-nav-left">
      <img class="bowtie" decoding="async" [src]="logo" />
      <div class="search-container">
        <form [formGroup]="form">
          <tidy-search-input
            class="header-search"
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'"
            [backgroundColor]="backgroundColor" />
        </form>
      </div>
      @if (
        form.value.search.length > 2
        ) {
        <div
          class="autocomplete-container"
          >
          <div class="autocomplete-list">
            @for (searchItem of searchItems; track searchItem; let first = $first) {
              <div>
                <div class="section-header" [ngStyle]="{'margin-top': !first ? '10px' : '0'}">
                  <tidy-text [body]="searchItem.list" />
                </div>
                @for (item of searchItem.items; track item; let last = $last) {
                  <div class="autocomplete-item" (click)="handleClickItem(item)">
                    <tidy-image [src]="item.image" />
                    <tidy-text [body]="item.title" />
                  </div>
                }
              </div>
            }
            @if (searchItems.length == 0 && form.value.search.length > 2) {
              <div class="autocomplete-item no-hover-effect">
                <tidy-text
                  [body]="('No results for: ' | translate) + form.value.search" />
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="top-nav-right">
      @if (showOnboarding && totalGoals && totalGoals !== 0 && totalGoals !== completedGoals) {
        <div id="onboarding" class="onboarding-container" (click)="openOnboarding()" [ngClass]="{'glow-animation': showGlowAnimation}">
          <tidy-image [src]="'assets/img/goal.svg'" />
          <tidy-text [body]="completedGoals + ' / ' + totalGoals + (' Goals Completed' | translate)" class="white" />
        </div>
      }
      @if (!isEmployerAccount) {
        @if (subscription?.trial_days_left > 0) {
          <div class="onboarding-container" (click)="goToSubscriptionPage()">
            <tidy-image [src]="'assets/img/crown.svg'" />
            <tidy-text [body]="subscription?.trial_days_left" class="white" /><span>&nbsp;</span>
            <tidy-text [body]="(subscription?.trial_days_left == 1 ? ('Day' | translate) : ('Days' | translate)) + (' Left in Free Trial' | translate)" class="white" />
          </div>
        }
        @if (hasNegativeBalance || isAccountSuspended) {
          <div class="onboarding-container" (click)="goToSubscriptionPage()" [ngClass]="{'glow-animation': showNegativeBalanceGlowAnimation}">
            <tidy-image [src]="'assets/img/white-alert.svg'" />
            <tidy-text [body]="hasNegativeBalance ? 'Subscription Payment Issue' : 'Plan Canceled Due to Payment Issue'" class="white" />
          </div>
        }
        <div
          [class.current-item]="headerProvider.showConciergePage"
          (click)="navigateToConcierge()"
          class="hover-effect"
          [matTooltip]="('Concierge' | translate)"
          [matTooltipPosition]="'below'"
          matTooltipClass="menu-item-tooltip below">
          <tidy-image
            [src]="'assets/img/menu-concierge-white.svg'"
            [isActive]="backgroundColor === '#1D2125' ? headerProvider.showConciergePage : false"
            class="header-icon no-right-margin"/>
        </div>
      }
      <div
        [class.current-item]="headerProvider.showNotificationCenter"
        (click)="navigateToNotificationCenter()"
        class="hover-effect"
        [matTooltip]="('Notifications' | translate)"
        [matTooltipPosition]="'below'"
        matTooltipClass="menu-item-tooltip below">
        <div style="position: relative; width: 25px;">
          <tidy-image
            [src]="headerProvider.showNotificationCenter && backgroundColor === '#1D2125' ? 'assets/img/notification-green.svg' : 'assets/img/notification-white.svg'"
            class="header-icon no-right-margin"/>
          @if (notificationCount > 0 && notificationCount < 10) {
            <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 50%; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
              {{notificationCount}}
            </div>
          }
          @if (notificationCount >= 10) {
            <div style="position: absolute; top: -8px; right: -8px; background: #CB393C; color: white; border-radius: 8px; min-width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 12px; padding: 0 4px; font-family: Inter, Arial, sans-serif;">
              9+
            </div>
          }
        </div>
      </div>
      <div
        [class.current-item]="showHelpDropdown"
        class="hover-effect"
        (click)="toggleHelpDropdown($event)"
        #helpIconRef>
        <tidy-image
          [src]="'assets/img/menu-help-white.svg'"
          [isActive]="backgroundColor === '#1D2125' ? showHelpDropdown : false"
          class="header-icon no-right-margin"/>
      </div>
      @if (showHelpDropdown) {
        <div #helpDropdownRef class="help-dropdown">
          <div class="help-dropdown-list">
            <div class="help-dropdown-item" (click)="navigateToWhatsNew()">
              <tidy-text [body]="'What\'s New?'" />
            </div>
            <div class="help-dropdown-item" (click)="navigateToDocuments()">
              <tidy-text [body]="'Documentation'" />
            </div>
            @if (!isEmployerAccount) {
              <div class="help-dropdown-item" (click)="goToAddSupportRequest()">
                <tidy-text [body]="'Contact Support'" />
              </div>
            }
          </div>
        </div>
      }
      <div
        class="initials-div hover-effect"
        [class.current-item]="showInitialsDropdown"
        (click)="toggleInitialsDropdown($event)"
        #initialsIconRef>
        <div>
          <div class="initials" [class.green]="backgroundColor === '#1D2125' ? showInitialsDropdown : false" [ngStyle]="{'color': backgroundColor}">{{initials}}</div>
        </div>
      </div>
      @if (showInitialsDropdown) {
        <div
          #initialsDropdownRef
          class="help-dropdown"
          style="right: 20px"
          >
          <div class="help-dropdown-list">
            <div class="help-dropdown-item" (click)="goToContactInfo()">
              <tidy-text [body]="'Contact Info'" />
            </div>
            <div class="help-dropdown-item" (click)="goToSubscriptionPage()">
              <tidy-text [body]="'Subscription'" />
            </div>
            <div class="help-dropdown-item" (click)="logout()">
              <tidy-text [body]="'Logout'" />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ion-header>